import { AfterViewInit, Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatSidenav } from '@angular/material/sidenav';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { catchError, from, of, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ThemeService } from '../../account/settings/services/theme.service';
import { NotificationService } from '../../account/settings/services/notification.service';
import { SidenavService } from '../sidenav/sidenav.service';
import { SignInService } from '../../account/sign-in/sign-in.service';
import { hasTotpSignIn } from '../../../utils/auth-state';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, AfterViewInit {

  @Input() inputSideNav!: MatSidenav  

  signedIn = false;
  themeIconName = 'brightness_auto';
  themeLabel = 'Tema: sistema';
  // 96px copies of assets/logo.png and assets/logo_dark.png
  logoSrc = '/imgs/logo-96.png';
  notificationIconName = 'notifications_active';
  notificationLabel = 'Turn Off';

  sidenavStatus$!: boolean
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    // private authService: AuthService,
    private router: Router, 
    private themeService: ThemeService,
    private notificationService: NotificationService,
    private sidenavService: SidenavService, 
    private signInService: SignInService,
    private auth: AngularFireAuth
  ) { }

  ngOnInit(): void {
    // user (onIdTokenChanged) also emits when the TOTP claim arrives in a refreshed token;
    // authState only emits on sign-in and sign-out, before the TOTP code is validated
    this.auth.user.pipe(
      switchMap(user => user ? from(hasTotpSignIn(user)) : of(false)),
      catchError(() => of(false)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(isAuthenticated => this.signedIn = isAuthenticated);

    //Sidenav
    this.sidenavService.sidenavStatus().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(b => {
      this.sidenavStatus$ = b
      if (this.sidenavStatus$){
        this.inputSideNav.open()
       } else {
        this.inputSideNav.close()
      }
     })
  }

  ngAfterViewInit(): void {
    //Theme
    // ThemeService applies the color-scheme; the header only shows the current mode
    this.themeService.mode$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(mode => {
      this.themeIconName = { light: 'light_mode', dark: 'dark_mode', system: 'brightness_auto' }[mode];
      this.themeLabel = `Tema: ${{ light: 'claro', dark: 'escuro', system: 'sistema' }[mode]} (clique para trocar)`;
    })

    // Logo of the palette on screen, also when the mode is "system"
    this.themeService.dark$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(dark => {
      this.logoSrc = dark ? '/imgs/logo_dark-96.png' : '/imgs/logo-96.png';
    })

    //Notification
    this.notificationService.notificationStatus().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(b => {
      if (b){
        this.notificationIconName = 'notifications_active';
        this.notificationLabel = 'Turn Off';
      } else {
        this.notificationIconName = 'notifications_off';
        this.notificationLabel = 'Turn On';
      }
    })
  }

  sidenavToggle(): void {
    console.info('HeaderComponent -> sidenavToggle')

    this.sidenavService.sidenavStatusChange(!this.inputSideNav.opened)
  }

  themeToogle(): void {
    console.info('HeaderComponent -> themeToogle')

    this.themeService.themeToogle()
  }

  notificationToogle(): void {
    console.info('HeaderComponent -> notificationToogle')

    this.notificationService.notificationToogle()
  }

  async logout(): Promise<void> {
    await this.signInService.signOut();
    this.signedIn = false;
    await this.router.navigate(['/account/sign-in']);
  }
}
